module.exports = __webpack_public_path__ + "static/media/conference_23.ac44caf8.jpg";